// Version : 0.0.1
// Author : VISHNU
//Last ADD : add update code not working changes changes for alignment unwanted code remove response handle changes for alignement input '
// MODFIED DATA : 06-08-2025

import LoanDisbursementActionTypes from './loan-index-disbursement.types';

/*********** FETCH PARTICULAR LOAN INDEX START ************************ */
export const fetchParticularLoanIndexDetailsStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_PARTICULAR_LOAN_INDEX_DETAILS_START,
	payload: addData,
});

export const fetchParticularLoanIndexDetailsSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_PARTICULAR_LOAN_INDEX_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchParticularLoanIndexDetailsFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.FETCH_PARTICULAR_LOAN_INDEX_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchParticularLoanIndexDetailsResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.FETCH_PARTICULAR_LOAN_INDEX_DETAILS_RESPONSE_RESET,
});

export const fetchParticularLoanIndexDetailsResponseChanged = () => ({
	type: LoanDisbursementActionTypes.FETCH_PARTICULAR_LOAN_INDEX_DETAILS_RESPONSE_CHANGED,
});
/*********** FETCH PARTICULAR LOAN INDEX END ************************ */

/*********** DELETE PARTICULAR LOAN INDEX START ************************ */
export const deleteParticularLoanIndexDetailsStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.DELETE_PARTICULAR_LOAN_INDEX_DETAILS_START,
	payload: addData,
});

export const deleteParticularLoanIndexDetailsSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.DELETE_PARTICULAR_LOAN_INDEX_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteParticularLoanIndexDetailsFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.DELETE_PARTICULAR_LOAN_INDEX_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteParticularLoanIndexDetailsResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.DELETE_PARTICULAR_LOAN_INDEX_DETAILS_RESPONSE_RESET,
});

export const deleteParticularLoanIndexDetailsResponseChanged = () => ({
	type: LoanDisbursementActionTypes.DELETE_PARTICULAR_LOAN_INDEX_DETAILS_RESPONSE_CHANGED,
});

/*********** DELETE PARTICULAR LOAN INDEX END ************************ */

/*********** FETCH FINANCE ACCOUNT START ************************ */
export const fetchFinanceAccountsListStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_FINANCE_ACCOUNTS_START,
	payload: addData,
});

export const fetchFinanceAccountsListSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_FINANCE_ACCOUNTS_SUCCESS,
	payload: successData,
});

export const fetchFinanceAccountsListFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.FETCH_FINANCE_ACCOUNTS_FAILURE,
	payload: failureData,
});

export const fetchFinanceAccountsListResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.FETCH_FINANCE_ACCOUNTS_RESPONSE_RESET,
});

export const fetchFinanceAccountsListResponseChanged = () => ({
	type: LoanDisbursementActionTypes.FETCH_FINANCE_ACCOUNTS_RESPONSE_CHANGED,
});

/*********** FETCH FINANCE ACCOUNT END ************************ */

/*********** FETCH LOAN SCHEDULE LIST START ************************ */
export const fetchLoanScheduleListStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_LOAN_SCHEDULE_LIST_START,
	payload: addData,
});

export const fetchLoanScheduleListSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_LOAN_SCHEDULE_LIST_SUCCESS,
	payload: successData,
});

export const fetchLoanScheduleListFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.FETCH_LOAN_SCHEDULE_LIST_FAILURE,
	payload: failureData,
});

export const fetchLoanScheduleListResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.FETCH_LOAN_SCHEDULE_LIST_RESPONSE_RESET,
});

export const fetchLoanScheduleListResponseChanged = () => ({
	type: LoanDisbursementActionTypes.FETCH_LOAN_SCHEDULE_LIST_RESPONSE_CHANGED,
});
/*********** FETCH LOAN SCHEDULE LIST START ************************ */

/*********** UPDATE LOANINDEX FUNER START ************************ */
export const updateLoanIndexFunderStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.UPDATE_LOANINDEX_FUNDER_START,
	payload: addData,
});

export const updateLoanIndexFunderSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.UPDATE_LOANINDEX_FUNDER_SUCCESS,
	payload: successData,
});

export const updateLoanIndexFunderFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.UPDATE_LOANINDEX_FUNDER_FAILURE,
	payload: failureData,
});

export const updateLoanIndexFunderResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.UPDATE_LOANINDEX_FUNDER_RESPONSE_RESET,
});

export const updateLoanIndexFunderResponseChanged = () => ({
	type: LoanDisbursementActionTypes.UPDATE_LOANINDEX_FUNDER_RESPONSE_CHANGED,
});
/*********** UPDATE LOANINDEX FUNER START ************************ */

/*********** UPDATE LOANINDEX MEETTIME START ************************ */
export const updateLoanIndexMeettimeStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.UPDATE_LOANINDEX_MEETTIME_START,
	payload: addData,
});

export const updateLoanIndexMeettimeSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.UPDATE_LOANINDEX_MEETTIME_SUCCESS,
	payload: successData,
});

export const updateLoanIndexMeettimeFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.UPDATE_LOANINDEX_MEETTIME_FAILURE,
	payload: failureData,
});

export const updateLoanIndexMeettimeResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.UPDATE_LOANINDEX_MEETTIME_RESPONSE_RESET,
});

export const updateLoanIndexMeettimeResponseChanged = () => ({
	type: LoanDisbursementActionTypes.UPDATE_LOANINDEX_MEETTIME_RESPONSE_CHANGED,
});
/*********** UPDATE LOANINDEX MEETTIME START ************************ */

/*********** UPDATE LOANINDEX PUROSE LOAN START ************************ */
export const updateLoanIndexPOLStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.UPDATE_LOANINDEX_POL_START,
	payload: addData,
});

export const updateLoanIndexPOLSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.UPDATE_LOANINDEX_POL_SUCCESS,
	payload: successData,
});

export const updateLoanIndexPOLFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.UPDATE_LOANINDEX_POL_FAILURE,
	payload: failureData,
});

export const updateLoanIndexPOLResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.UPDATE_LOANINDEX_POL_RESPONSE_RESET,
});

export const updateLoanIndexPOLResponseChanged = () => ({
	type: LoanDisbursementActionTypes.UPDATE_LOANINDEX_POL_RESPONSE_CHANGED,
});
/*********** UPDATE LOANINDEX PUROSE LOAN END ************************ */

/*********** CREATE LOAN INDEX DISBURESEMENT START ************************ */
export const createLoanIndexDisbursementStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.CREATE_LOANINDEX_DISBURSEMENT_START,
	payload: addData,
});

export const createLoanIndexDisbursementSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.CREATE_LOANINDEX_DISBURSEMENT_SUCCESS,
	payload: successData,
});

export const createLoanIndexDisbursementFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.CREATE_LOANINDEX_DISBURSEMENT_FAILURE,
	payload: failureData,
});

export const createLoanIndexDisbursementResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.CREATE_LOANINDEX_DISBURSEMENT_RESPONSE_RESET,
});

export const createLoanIndexDisbursementResponseChanged = () => ({
	type: LoanDisbursementActionTypes.CREATE_LOANINDEX_DISBURSEMENT_RESPONSE_CHANGED,
});
/*********** CREATE LOAN INDEX DISBURESEMENT END ************************ */

/*********** CREATE TRANSACTION DISBURSMENT START ************************ */
export const createTransactionDisbursementStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.CREATE_TRANSACTION_DISBURSEMENT_START,
	payload: addData,
});

export const createTransactionDisbursementSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.CREATE_TRANSACTION_DISBURSEMENT_SUCCESS,
	payload: successData,
});

export const createTransactionDisbursementFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.CREATE_TRANSACTION_DISBURSEMENT_FAILURE,
	payload: failureData,
});

export const createTransactionDisbursementResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.CREATE_TRANSACTION_DISBURSEMENT_RESPONSE_RESET,
});

export const createTransactionDisbursementResponseChanged = () => ({
	type: LoanDisbursementActionTypes.CREATE_TRANSACTION_DISBURSEMENT_RESPONSE_CHANGED,
});
/*********** CREATE TRANSACTION DISBURSMENT END ************************ */

/*********** CREATE TRANSACTION ADDITIONAL CHARGES START ************************ */
export const createTransactionAdditionalChargesStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.CREATE_TRANSACTION_ADDITIONAL_CHARGES_START,
	payload: addData,
});

export const createTransactionAdditionalChargesSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.CREATE_TRANSACTION_ADDITIONAL_CHARGES_SUCCESS,
	payload: successData,
});

export const createTransactionAdditionalChargesFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.CREATE_TRANSACTION_ADDITIONAL_CHARGES_FAILURE,
	payload: failureData,
});

export const createTransactionAdditionalChargesResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.CREATE_TRANSACTION_ADDITIONAL_CHARGES_RESPONSE_RESET,
});

export const createTransactionAdditionalChargesResponseChanged = () => ({
	type: LoanDisbursementActionTypes.CREATE_TRANSACTION_ADDITIONAL_CHARGES_RESPONSE_CHANGED,
});

/*********** CREATE TRANSACTION ADDITIONAL CHARGES END ************************ */

/*********** FETCH NEXT TRANSACTION SERIAL NO START ************************ */
export const fetchNextTransactionSerialNoStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_NEXT_TRANSACTION_SERIAL_NO_START,
	payload: addData,
});

export const fetchNextTransactionSerialNoSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_NEXT_TRANSACTION_SERIAL_NO_SUCCESS,
	payload: successData,
});

export const fetchNextTransactionSerialNoFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.FETCH_NEXT_TRANSACTION_SERIAL_NO_FAILURE,
	payload: failureData,
});

export const fetchNextTransactionSerialNoResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.FETCH_NEXT_TRANSACTION_SERIAL_NO_RESPONSE_RESET,
});

export const fetchNextTransactionSerialNoResponseChanged = () => ({
	type: LoanDisbursementActionTypes.FETCH_NEXT_TRANSACTION_SERIAL_NO_RESPONSE_CHANGED,
});

/*********** FETCH NEXT TRANSACTION SERIAL NO END ************************ */

/*********** FETCH PRODUCT ACCOUNT DEATIL START ************************ */
export const fetchProductAccountDetailsStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_PRODUCT_ACCOUNT_DETAILS_START,
	payload: addData,
});

export const fetchProductAccountDetailsSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_PRODUCT_ACCOUNT_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchProductAccountDetailsFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.FETCH_PRODUCT_ACCOUNT_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchProductAccountDetailsResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.FETCH_PRODUCT_ACCOUNT_DETAILS_RESPONSE_RESET,
});

export const fetchProductAccountDetailsResponseChanged = () => ({
	type: LoanDisbursementActionTypes.FETCH_PRODUCT_ACCOUNT_DETAILS_RESPONSE_CHANGED,
});
/*********** FETCH PRODUCT ACCOUNT DEATIL END ************************ */

/*********** FETCH VOUCHER BASED ON COMPANY START ************************ */
export const fetchVoucherCountBasedOnCompanyStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_VOUCHER_COUNT_BASED_ON_COMPANY_START,
	payload: addData,
});

export const fetchVoucherCountBasedOnCompanySuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_VOUCHER_COUNT_BASED_ON_COMPANY_SUCCESS,
	payload: successData,
});

export const fetchVoucherCountBasedOnCompanyFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.FETCH_VOUCHER_COUNT_BASED_ON_COMPANY_FAILURE,
	payload: failureData,
});

export const fetchVoucherCountBasedOnCompanyResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.FETCH_VOUCHER_COUNT_BASED_ON_COMPANY_RESPONSE_RESET,
});

export const fetchVoucherCountBasedOnCompanyResponseChanged = () => ({
	type: LoanDisbursementActionTypes.FETCH_VOUCHER_COUNT_BASED_ON_COMPANY_RESPONSE_CHANGED,
});
/*********** FETCH VOUCHER BASED ON COMPANY END ************************ */

/*********** FETCH INTER BRANCH CONTRA START ************************ */
export const fetchInterBranchContraStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_INTER_BRANCH_CONTRA_START,
	payload: addData,
});

export const fetchInterBranchContraSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_INTER_BRANCH_CONTRA_SUCCESS,
	payload: successData,
});

export const fetchInterBranchContraFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.FETCH_INTER_BRANCH_CONTRA_FAILURE,
	payload: failureData,
});

export const fetchInterBranchContraResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.FETCH_INTER_BRANCH_CONTRA_RESPONSE_RESET,
});

export const fetchInterBranchContraResponseChanged = () => ({
	type: LoanDisbursementActionTypes.FETCH_INTER_BRANCH_CONTRA_RESPONSE_CHANGED,
});
/*********** FETCH INTER BRANCH CONTRA END ************************ */

/*********** FETCH ALL PRODUCT ADDITIONAL ACCOUNT START ************************ */
export const fetchAllProductAdditionalAccountStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_ALL_PRODUCT_ADDITIONAL_ACCOUNT_START,
	payload: addData,
});

export const fetchAllProductAdditionalAccountSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_ALL_PRODUCT_ADDITIONAL_ACCOUNT_SUCCESS,
	payload: successData,
});

export const fetchAllProductAdditionalAccountFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.FETCH_ALL_PRODUCT_ADDITIONAL_ACCOUNT_FAILURE,
	payload: failureData,
});

export const fetchAllProductAdditionalAccountResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.FETCH_ALL_PRODUCT_ADDITIONAL_ACCOUNT_RESPONSE_RESET,
});

export const fetchAllProductAdditionalAccountResponseChanged = () => ({
	type: LoanDisbursementActionTypes.FETCH_ALL_PRODUCT_ADDITIONAL_ACCOUNT_RESPONSE_CHANGED,
});
/*********** FETCH ALL PRODUCT ADDITIONAL ACCOUNT END ************************ */

/*********** FETCH ALL RANGE PRODUCT START ************************ */
export const fetchAllRangeProductStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_ALL_RANGE_PRODUCT_START,
	payload: addData,
});

export const fetchAllRangeProductSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_ALL_RANGE_PRODUCT_SUCCESS,
	payload: successData,
});

export const fetchAllRangeProductFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.FETCH_ALL_RANGE_PRODUCT_FAILURE,
	payload: failureData,
});

export const fetchAllRangeProductResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.FETCH_ALL_RANGE_PRODUCT_RESPONSE_RESET,
});

export const fetchAllRangeProductResponseChanged = () => ({
	type: LoanDisbursementActionTypes.FETCH_ALL_RANGE_PRODUCT_RESPONSE_CHANGED,
});
/*********** FETCH ALL RANGE PRODUCT END ************************ */

/*********** CREATE TOPUP LOAN INDEX START ************************ */
export const createTopupLoanIndexStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.CREATE_TOPUP_LOAN_INDEX_START,
	payload: addData,
});

export const createTopupLoanIndexSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.CREATE_TOPUP_LOAN_INDEX_SUCCESS,
	payload: successData,
});

export const createTopupLoanIndexFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.CREATE_TOPUP_LOAN_INDEX_FAILURE,
	payload: failureData,
});

export const createTopupLoanIndexResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.CREATE_TOPUP_LOAN_INDEX_RESPONSE_RESET,
});

export const createTopupLoanIndexResponseChanged = () => ({
	type: LoanDisbursementActionTypes.CREATE_TOPUP_LOAN_INDEX_RESPONSE_CHANGED,
});

/*********** CREATE TOPUP LOAN INDEX END ************************ */

/** ***************** FETCH INSTRUMENT LIST START *********************** */
export const fetchInstumentListStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_INSTRUMENT_LIST_START,
	payload: addData,
});

export const fetchInstumentListSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_INSTRUMENT_LIST_SUCCESS,
	payload: successData,
});

export const fetchInstumentListFailure = (failureData: any) => ({
	type: LoanDisbursementActionTypes.FETCH_INSTRUMENT_LIST_FAILURE,
	payload: failureData,
});

export const fetchInstumentListResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.FETCH_INSTRUMENT_LIST_RESPONSE_RESET,
});

export const fetchInstumentListResponseChanged = () => ({
	type: LoanDisbursementActionTypes.FETCH_INSTRUMENT_LIST_RESPONSE_CHANGED,
});

/** ***************** FETCH INSTRUMENT LIST END *********************** */

/** ***************** GET INVESTOR DETAILS START *********************** */
export const getInvestorDetailsStart = (addData: any) => ({
	type: LoanDisbursementActionTypes.GET_INVESTOR_DETAILS_START,
	payload: addData,
});

export const getInvestorDetailsSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.GET_INVESTOR_DETAILS_SUCCESS,
	payload: successData,
});

export const getInvestorDetailsFailure = (failureData: unknown) => ({
	type: LoanDisbursementActionTypes.GET_INVESTOR_DETAILS_FAILURE,
	payload: failureData,
});

export const getInvestorDetailsResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.GET_INVESTOR_DETAILS_RESPONSE_RESET,
});

export const getInvestorDetailsResponseChanged = () => ({
	type: LoanDisbursementActionTypes.GET_INVESTOR_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET INVESTOR DETAILS END *********************** */

/** ***************** HDFC PAYOUT TRANSACTION START *********************** */
export const hdfcPayoutTransactionStart = (getData: any) => ({
	type: LoanDisbursementActionTypes.HDFC_PAYOUT_TRANSACTION_START,
	payload: getData,
});

export const hdfcPayoutTransactionSuccess = (successData: any) => ({
	type: LoanDisbursementActionTypes.HDFC_PAYOUT_TRANSACTION_SUCCESS,
	payload: successData,
});

export const hdfcPayoutTransactionFailure = (failureData: any) => ({
	type: LoanDisbursementActionTypes.HDFC_PAYOUT_TRANSACTION_FAILURE,
	payload: failureData,
});

export const hdfcPayoutTransactionResponseResetStart = () => ({
	type: LoanDisbursementActionTypes.HDFC_PAYOUT_TRANSACTION_RESPONSE_RESET,
});

export const hdfcPayoutTransactionResponseChanged = () => ({
	type: LoanDisbursementActionTypes.HDFC_PAYOUT_TRANSACTION_RESPONSE_CHANGED,
});
/** ***************** HDFC PAYOUT TRANSACTION END *********************** */
